import script from "./ViewListRendering.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewListRendering.vue?vue&type=script&setup=true&lang=js"

import "./ViewListRendering.vue?vue&type=style&index=0&id=1b6b0dad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6b0dad"]])

export default __exports__